import { createAsyncThunk } from '@reduxjs/toolkit'
import ICaptchaResponse from '@/types/captcha-response.interface'
import AuthService from '@/services/auth.service'

const fetchCaptcha = createAsyncThunk<ICaptchaResponse>('captcha/fetchCaptchaStatus', async () => {
  const data = await AuthService.getCaptcha()

  return data
})

export default fetchCaptcha
